var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useContext, useEffect, useRef, useState } from '@max/max';
import { request } from '@max/meituan-uni-network';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import { getCommonInfo, getUtmMedium } from './utils/helper';
import './index.scss';
import Card from './components/card';
import DoubleCard from './components/doubleCard';
import HorizontalCard from './components/horizontalCard';
import ScrollView from '@hfe/max-scrollview';
import LoadingView from '@max/leez-loading-view';
import ThreeColumnsCard from './components/threeColumnsCard';
const isWeb = true;
const isMRN = false;
const MyComponent = (props) => {
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    const moduleId = ctx._moduleId;
    const { supplyGroupId, showNum, moreNum, _raptorReport, _LXReport, dealStyle, pageSourceType, moreBtnConfig, relativeCity, isShowChoiceness, customTagConfig, silentLoad } = props;
    // 状态管理
    const [goodList, setGoodList] = useState([]);
    const [basicParams, setBasicParams] = useState(undefined);
    const [lastDealId, setLastDealId] = useState(undefined);
    const [hideMore, setHideMore] = useState(false);
    const { reportLog } = _raptorReport || {};
    const [isLoading, setIsLoading] = useState(false);
    // 统一管理当前生效的城市 ID
    const cityIdRef = useRef(null);
    const prevPlayUnifyIdRef = useRef(null);
    const pageNum = useRef(1);
    const isLastPage = useRef(false);
    // 初始化状态标记
    const initializationRef = useRef({
        isInitialized: false,
        isInitializing: false
    });
    const useNewPageNo = useRef(false);
    const hasPinnerList = useRef(false);
    const pinnerLists = useRef([]);
    // 攻略联动请求的时序ID
    const guideRequestId = useRef(0);
    // 当前有效的攻略ID（用于加载更多时校验）
    const activeGuideId = useRef(0);
    // 缓存最新的攻略联动参数，供 hotelRefreshApi 复用
    const lastGuideParamsRef = useRef(null);
    function init() {
        return __awaiter(this, void 0, void 0, function* () {
            // 防止重复初始化
            if (initializationRef.current.isInitialized || initializationRef.current.isInitializing) {
                return;
            }
            initializationRef.current.isInitializing = true;
            try {
                isLastPage.current = false;
                pageNum.current = 1;
                const param = yield getCommonInfo(ctx);
                // 若初始化期间已收到城市切换事件，cityIdRef 已有值，直接覆盖
                const finalParam = cityIdRef.current !== null ? Object.assign(Object.assign({}, param), { cityId: cityIdRef.current }) : param;
                setBasicParams(finalParam);
                yield fetchData(showNum !== null && showNum !== void 0 ? showNum : 4, finalParam);
                initializationRef.current.isInitialized = true;
            }
            catch (error) {
                reportLog === null || reportLog === void 0 ? void 0 : reportLog('初始化异常', error);
            }
            finally {
                initializationRef.current.isInitializing = false;
            }
        });
    }
    // 获取商品列表数据
    const fetchData = (num, param) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        // 节流逻辑：只检查 isLoading 状态，避免阻止初始化过程中的请求
        console.log('fetchData==', isLoading, isLastPage.current);
        if (isLoading) {
            console.log('请求被节流：正在加载中');
            return;
        }
        if (isLastPage.current) {
            return;
        }
        try {
            setIsLoading(true);
            const pinnedProductIds = ((_a = pinnerLists.current) === null || _a === void 0 ? void 0 : _a.length) > 0 ? pinnerLists.current.map((item) => item === null || item === void 0 ? void 0 : item.goodsId) : null;
            const reqParams = {
                supplyGroupId: supplyGroupId,
                lastDealId,
                userRequestInfoDTO: param !== null && param !== void 0 ? param : basicParams,
                pageNum: pageNum.current,
                pageSize: num,
                querySource: 2,
                channel: pageSourceType,
                utm_medium: getUtmMedium(),
                // 获取渠道来源
                pinnedProductIds
            };
            // 请求配置
            const fetchOptions = {
                url: 'https://apitrip.meituan.com/landing/page/vacation/goods/list',
                method: 'POST',
                data: reqParams,
                header: {
                    'content-type': 'application/json'
                },
                withCredentials: true
            };
            // 测试用
            // const res = {
            //   data: mockdata
            // }
            const res = yield request(fetchOptions);
            if (!(res === null || res === void 0 ? void 0 : res.data)) {
                reportLog === null || reportLog === void 0 ? void 0 : reportLog('maker 度假deal组件接口异常 - 无响应数据', new Error('No response data'), {
                    level: 'info'
                });
                return;
            }
            if (res.data.status !== 0) {
                reportLog === null || reportLog === void 0 ? void 0 : reportLog('maker 度假deal组件接口异常 - 错误码异常', new Error(`Error code: ${res.data.code}`), {
                    level: 'info'
                });
                return;
            }
            let newGoodsList = ((_b = res.data.data) === null || _b === void 0 ? void 0 : _b.goodsList) || [];
            // 检查置顶数据是否有效（防止攻略切换后的旧请求使用错误的置顶数据）
            if (pageNum.current === 1 && pinnerLists.current.length > 0 && hasPinnerList.current) {
                // 只有当 activeGuideId 匹配时才使用置顶数据
                if (activeGuideId.current > 0 && activeGuideId.current === guideRequestId.current) {
                    newGoodsList = pinnerLists.current.concat(((_c = res.data.data) === null || _c === void 0 ? void 0 : _c.goodsList) || []);
                    hasPinnerList.current = false;
                }
                else {
                    console.log('置顶数据已过期，不使用。activeGuideId:', activeGuideId.current, 'currentGuideId:', guideRequestId.current);
                }
            }
            const lastPage = ((_d = res.data.data) === null || _d === void 0 ? void 0 : _d.lastPage) || newGoodsList.length === 0;
            isLastPage.current = lastPage;
            // 更新状态
            setHideMore(lastPage); // 是否为最后一页
            setLastDealId((_e = res.data.data) === null || _e === void 0 ? void 0 : _e.lastDealId); // 更新分页标识
            // 更新商品列表（追加模式）
            setGoodList(prevList => {
                const updatedList = prevList && (pageNum === null || pageNum === void 0 ? void 0 : pageNum.current) > 1 ? [...prevList, ...newGoodsList] : [...newGoodsList];
                return updatedList;
            });
        }
        catch (error) {
            reportLog === null || reportLog === void 0 ? void 0 : reportLog('maker 度假deal组件接口异常', error);
        }
        finally {
            setIsLoading(false);
        }
    });
    //切换城市
    const handleCityChange = (cityId) => __awaiter(void 0, void 0, void 0, function* () {
        console.log('度假跟团供给::handleCityChange', cityId);
        // 如果没有 value，且尚未初始化，走初始化逻辑
        if (!(cityId === null || cityId === void 0 ? void 0 : cityId.value)) {
            if (!initializationRef.current.isInitialized && !initializationRef.current.isInitializing) {
                init();
            }
            return;
        }
        const currentCityId = Number(cityId === null || cityId === void 0 ? void 0 : cityId.value);
        // 比较当前 cityId 和上一次的 cityId
        if (cityIdRef.current === currentCityId) {
            console.log('城市ID未变化,跳过更新');
            return;
        }
        // 如果正在加载中，跳过请求（不写入 cityIdRef，避免去重误判）
        if (isLoading) {
            console.log('城市切换被跳过：正在加载中');
            return;
        }
        // 写入 cityIdRef：初始化期间 init() 会直接读取，正常情况下请求发出前写入
        cityIdRef.current = currentCityId;
        // 如果正在初始化，城市 ID 已写入 cityIdRef，init() 完成时会自动使用
        if (initializationRef.current.isInitializing) {
            console.log('城市切换被暂存：初始化完成时自动使用', currentCityId);
            return;
        }
        try {
            isLastPage.current = false;
            pageNum.current = 1;
            const param = yield getCommonInfo(ctx);
            const newParam = Object.assign(Object.assign({}, param), { cityId: currentCityId });
            // 更新状态
            setBasicParams(newParam);
            setGoodList([]); // 清空列表
            setLastDealId(undefined);
            setHideMore(false);
            // 更新数据
            yield fetchData(showNum !== null && showNum !== void 0 ? showNum : 4, newParam);
            initializationRef.current.isInitialized = true;
        }
        catch (error) {
            reportLog === null || reportLog === void 0 ? void 0 : reportLog('切换城市异常', error);
        }
    });
    // 单独的攻略联动请求函数（带时序ID）
    const fetchGuideData = (num, param, experienceInfo, currentRequestId) => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g, _h, _j, _k, _l;
        pinnerLists.current = [];
        try {
            setIsLoading(true);
            const reqParams = {
                supplyGroupId: supplyGroupId,
                userRequestInfoDTO: param,
                pageNum: 1,
                pageSize: num,
                querySource: 2,
                channel: pageSourceType,
                utm_medium: getUtmMedium()
                // ...experienceInfo,
            };
            const firstReqParams = Object.assign(Object.assign({}, reqParams), experienceInfo);
            const fetchOptions = {
                url: 'https://apitrip.meituan.com/landing/page/vacation/goods/list',
                method: 'POST',
                data: firstReqParams,
                header: {
                    'content-type': 'application/json'
                },
                withCredentials: true
            };
            const res = yield request(fetchOptions);
            // 检查请求是否过期（只展示最新的请求）
            if (currentRequestId !== guideRequestId.current) {
                console.log('攻略请求已过期，忽略响应。currentId:', currentRequestId, 'latestId:', guideRequestId.current);
                setIsLoading(false);
                return;
            }
            if (!(res === null || res === void 0 ? void 0 : res.data) || res.data.status !== 0) {
                reportLog === null || reportLog === void 0 ? void 0 : reportLog('maker 度假deal组件攻略联动接口异常', new Error('Response error'));
                setIsLoading(false);
                return;
            }
            const firstPageData = ((_f = res.data.data) === null || _f === void 0 ? void 0 : _f.goodsList) || [];
            // 第一次请求的数据是置顶数据，需要存储
            hasPinnerList.current = true;
            pinnerLists.current = firstPageData;
            // 标记当前活跃的攻略ID
            activeGuideId.current = currentRequestId;
            // 如果第一次返回数据少于num条，继续请求第二次
            if (firstPageData.length < num) {
                // 第二次请求不需要 experienceInfo，只需要基础参数和置顶ID
                const secondReqParams = Object.assign(Object.assign(Object.assign({}, reqParams), { pageSize: num - firstPageData.length }), (firstPageData.length > 0 ? {
                    pinnedProductIds: firstPageData.map((item) => item === null || item === void 0 ? void 0 : item.goodsId)
                } : {}));
                const secondRes = yield request(Object.assign(Object.assign({}, fetchOptions), { data: secondReqParams }));
                // 再次检查请求是否过期
                if (currentRequestId !== guideRequestId.current) {
                    console.log('第二次攻略请求已过期，忽略响应');
                    setIsLoading(false);
                    return;
                }
                if ((secondRes === null || secondRes === void 0 ? void 0 : secondRes.data) && secondRes.data.status === 0) {
                    const secondPageData = ((_g = secondRes.data.data) === null || _g === void 0 ? void 0 : _g.goodsList) || [];
                    // 第二次数据只用于展示，不存入 pinnerLists
                    const combinedData = [...firstPageData, ...secondPageData];
                    setGoodList([...combinedData]);
                    // pinnerLists.current 保持只有第一次的数据（置顶数据）
                    setLastDealId((_h = secondRes.data.data) === null || _h === void 0 ? void 0 : _h.lastDealId);
                    setHideMore(((_j = secondRes.data.data) === null || _j === void 0 ? void 0 : _j.lastPage) || false);
                }
            }
            else {
                // 第一次数据足够，直接展示
                setGoodList(firstPageData);
                setLastDealId((_k = res.data.data) === null || _k === void 0 ? void 0 : _k.lastDealId);
                setHideMore(((_l = res.data.data) === null || _l === void 0 ? void 0 : _l.lastPage) || false);
                useNewPageNo.current = true;
            }
        }
        catch (error) {
            reportLog === null || reportLog === void 0 ? void 0 : reportLog('攻略联动请求异常', error);
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleTravelAroundGuideChange = (experienceIdInfo) => __awaiter(void 0, void 0, void 0, function* () {
        console.log('handleTravelAroundGuideChange==', experienceIdInfo, goodList);
        const { cityId, productInfoList = [], playUnifyIdString } = experienceIdInfo || {};
        // 清空旧的置顶数据
        hasPinnerList.current = false;
        pinnerLists.current = [];
        activeGuideId.current = 0; // 重置活跃ID
        // 如果没有 value，且尚未初始化，走初始化逻辑
        if (!cityId && !playUnifyIdString) {
            if (!initializationRef.current.isInitialized && !initializationRef.current.isInitializing) {
                init();
            }
            return;
        }
        isLastPage.current = false;
        pageNum.current = 1;
        const currentCityId = Number(cityId);
        // 生成新的请求ID
        const currentRequestId = ++guideRequestId.current;
        console.log('发起攻略联动请求，requestId:', currentRequestId);
        try {
            const param = yield getCommonInfo(ctx);
            const newParam = Object.assign(Object.assign({}, param), { cityId: currentCityId });
            const experienceInfo = {
                experienceId: playUnifyIdString,
                destinationSwitch: true,
                destinationList: productInfoList
            };
            // 缓存攻略参数，供 hotelRefreshApi 复用
            lastGuideParamsRef.current = {
                param: newParam,
                experienceInfo
            };
            // 更新状态
            setBasicParams(newParam);
            setLastDealId(undefined);
            setHideMore(false);
            // 使用单独的请求函数
            yield fetchGuideData(showNum !== null && showNum !== void 0 ? showNum : 4, newParam, experienceInfo, currentRequestId);
            // 更新 ref 中存储的 cityId 和初始化状态
            cityIdRef.current = currentCityId;
            initializationRef.current.isInitialized = true;
        }
        catch (error) {
            reportLog === null || reportLog === void 0 ? void 0 : reportLog('联动攻略组件事件异常', error);
        }
    });
    // 点击加载更多
    function handleMore() {
        if (useNewPageNo.current) {
            pageNum.current = 0;
            useNewPageNo.current = false;
        }
        pageNum.current = pageNum.current + 1;
        fetchData(moreNum !== null && moreNum !== void 0 ? moreNum : 10, basicParams);
    }
    useEffect(() => {
        var _a, _b;
        if (window.H5guard) {
            window.H5guard.init({
                xhrHook: true,
                fetchHook: true,
                domains: ['appsec-mobile.sec.test.sankuai.com', '20313-rznvs-sl-vss.grocery.test.sankuai.com', 'api.hotel.test.meituan.com', 'apihotel.meituan.com'],
                forceKNBSign: false,
                yodaEnv: 'test',
                whitePaths: ['throne-hfe.meituan.com/api/throne', 'i.c.waimai.test.sankuai.com/aaa'],
                geo: false
            });
        }
        // 注册城市变化监听
        if (relativeCity === "citySelection") {
            (_a = props === null || props === void 0 ? void 0 : props._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', handleCityChange);
        }
        if (relativeCity === "aroundRecommendGuide") {
            (_b = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _b === void 0 ? void 0 : _b.on('travelAroundGuideChange', handleTravelAroundGuideChange);
        }
        // 直接初始化，避免时序问题
        if (relativeCity !== 'aroundRecommendGuide') {
            init();
        }
        return () => {
            var _a, _b;
            if (relativeCity === "citySelection") {
                (_a = props === null || props === void 0 ? void 0 : props._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged', handleCityChange);
            }
            if (relativeCity === "aroundRecommendGuide") {
                (_b = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _b === void 0 ? void 0 : _b.off('travelAroundGuideChange', handleTravelAroundGuideChange);
            }
        };
    }, []);
    // 监听 hotelRefreshApi 事件，始终注册，不受 relativeCity 影响
    useEffect(() => {
        var _a;
        const handleHotelRefreshApi = () => {
            // 重置分页状态
            isLastPage.current = false;
            pageNum.current = 1;
            // 清空列表
            setGoodList([]);
            setLastDealId(undefined);
            setHideMore(false);
            // 攻略联动模式下复用最新的攻略参数
            if (lastGuideParamsRef.current) {
                const currentRequestId = ++guideRequestId.current;
                const { param, experienceInfo } = lastGuideParamsRef.current;
                fetchGuideData(showNum !== null && showNum !== void 0 ? showNum : 4, param, experienceInfo, currentRequestId);
            }
            else {
                fetchData(showNum !== null && showNum !== void 0 ? showNum : 4, basicParams);
            }
        };
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('hotelRefreshApi', handleHotelRefreshApi);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('hotelRefreshApi', handleHotelRefreshApi);
        };
    }, []);
    const calcMarginRight = (index) => {
        if (true) {
            if ((index + 1) % 3 === 0) {
                return '0rpx';
            }
            return '12rpx';
        }
    };
    const wrapperClassMap = {
        horizontal: 'component-wrapper-horizontal',
        double: 'component-wrapper-double',
        single: 'component-wrapper'
    };
    return <View className={wrapperClassMap[dealStyle] || 'component-wrapper'}>
      {dealStyle === 'three' && (goodList === null || goodList === void 0 ? void 0 : goodList.length) > 0 ? <>
          <View className="component-div-three">
            {goodList.map((item, index) => <View className="component-div-three-columns" key={(item === null || item === void 0 ? void 0 : item.goodsId) || index} style={{
        marginRight: calcMarginRight(index)
    }}>
                  <ThreeColumnsCard {...props} goodInfo={item} index={index} supplyGroupId={supplyGroupId} _LXReport={_LXReport}/>
                </View>)}
          </View>
          {!hideMore && !isLoading && <View onClick={handleMore} style={{
        marginLeft: 0,
        width: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnWidth) || 172) + 'rpx',
        height: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnHeight) || 48) + 'rpx',
        overflow: 'hidden',
        marginTop: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.marginTop) || 24) + 'rpx',
        marginBottom: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.marginBottom) || 24) + 'rpx'
    }}>
              <Image style={{
        width: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnWidth) || 172) + 'rpx',
        height: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnHeight) || 48) + 'rpx'
    }} source={{
        uri: (moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtn) || 'https://img.meituan.net/makerjiulv/aa49d8cb1843552f854bdcaafb1e461f4218.png'
    }} resizeMode="contain"/>
            </View>}
        </> : dealStyle === 'three' && (goodList === null || goodList === void 0 ? void 0 : goodList.length) === 0 && !isLoading ? <>
            {!silentLoad && <View className="component-empty-state">
              <Text>暂无数据</Text>
            </View>}
          </> : <></>}


      {(dealStyle === 'double' || dealStyle === 'single') && (goodList === null || goodList === void 0 ? void 0 : goodList.length) > 0 ? <>
          <View className="component-div">
            {goodList.map((item, index) => item && (dealStyle === 'double' ? <DoubleCard {...props} key={(item === null || item === void 0 ? void 0 : item.goodsId) || index} goodInfo={item} index={index} supplyGroupId={supplyGroupId} _LXReport={_LXReport}/> : <Card {...props} key={(item === null || item === void 0 ? void 0 : item.goodsId) || index} goodInfo={item} index={index} supplyGroupId={supplyGroupId} _LXReport={_LXReport}/>))}
          </View>
          {!hideMore && !isLoading && <View onClick={handleMore} style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        height: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnHeight) || 48) + 'rpx',
        overflow: 'hidden',
        marginTop: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.marginTop) || 24) + 'rpx',
        marginBottom: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.marginBottom) || 24) + 'rpx'
    }}>
            <Image style={{
        width: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnWidth) || 178) + 'rpx',
        height: ((moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtnHeight) || 48) + 'rpx'
    }} source={{
        uri: (moreBtnConfig === null || moreBtnConfig === void 0 ? void 0 : moreBtnConfig.moreBtn) || 'https://img.meituan.net/makerjiulv/aa49d8cb1843552f854bdcaafb1e461f4218.png'
    }} resizeMode="contain"/>
          </View>}
        </> : !isLoading && (dealStyle === 'double' || dealStyle === 'single') ? !silentLoad ? <View className="component-empty-state">
          <Text>暂无数据</Text>
        </View> : <View /> : <View />}
      
      {dealStyle === 'horizontal' && <ScrollView horizontal showsHorizontalScrollIndicator={false} onEndReachedThreshold={200} onEndReached={handleMore} className="deal-horizontal">
          {goodList.map((item, index) => item && <HorizontalCard {...props} key={(item === null || item === void 0 ? void 0 : item.goodsId) || index} goodInfo={item} index={index} supplyGroupId={supplyGroupId} _LXReport={_LXReport}/>)}
          {!silentLoad && <LoadingView level="medium" content="正在加载更多" style={!isLoading && {
        display: 'none'
    }}/>}
        </ScrollView>}
    </View>;
};
export default memo(MyComponent);
